import React from "react";
const DevContext = React.createContext({});
const useDevService = () => {
  const service = React.useContext(DevContext);
  const serviceRef = React.useRef(service);
  serviceRef.current = service;
  return React.useCallback(() => serviceRef.current, []);
};
const useTrackRender = (componentName) => React.useContext(DevContext)?.trackRender?.(componentName);
const useDevGiphyRequestService = () => React.useContext(DevContext)?.giphyRequestService;
const useDevAiRequestService = () => React.useContext(DevContext)?.aiRequestService;
const useDevConnectionState = () => React.useContext(DevContext)?.connectionState ?? {
  type: "NO_MODIFICATION"
};
const useDevLogBi = () => {
  return React.useContext(DevContext)?.logBi ?? void 0;
};
const useDevPmNodeAttrs = () => React.useContext(DevContext)?.pmNodeAttrs ?? void 0;
const useDevPickMedia = () => React.useContext(DevContext)?.pickMedia ?? void 0;
export {
  DevContext,
  useDevAiRequestService,
  useDevConnectionState,
  useDevGiphyRequestService,
  useDevLogBi,
  useDevPickMedia,
  useDevPmNodeAttrs,
  useDevService,
  useTrackRender
};
//# sourceMappingURL=DevContext.js.map
